import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IPaginationState {
  page: number;
  limit: number;
  count: number;
  lastVisitedPage: number;
  transactionType?: string;
  paginatedData: Record<
    number,
    {
      data: any[];
      filters: Record<string, string | number>;
      searchQuery: string;
    }
  >;
  filters: Record<string, string | number>;
  searchQuery: string;
}

const initialState: IPaginationState = {
  page: 1,
  limit: 10,
  count: 0,
  lastVisitedPage: 1,
  paginatedData: {},
  filters: {},
  searchQuery: "",
};

const PaginationSlice = createSlice({
  name: "TransactionPagination",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setLimit: (state, action: PayloadAction<number>) => {
      state.limit = action.payload;
    },
    setCount: (state, action: PayloadAction<number>) => {
      state.count = action.payload;
    },
    setTransactionType: (state, action: PayloadAction<string>) => {
      state.transactionType = action.payload;
    },
    setPaginatedData: (
      state,
      action: PayloadAction<{ page: number; data: any }>,
    ) => {
      const { page, data }: { page: number; data: any[] } = action.payload;
      state.paginatedData[page] = {
        data,
        filters: state.filters,
        searchQuery: state.searchQuery,
      };
    },
    setLastVisitedPage: (state, action: PayloadAction<number>) => {
      state.lastVisitedPage = action.payload;
    },
    clearPaginatedData: (state) => {
      state.paginatedData = {};
    },
    setFilters: (
      state,
      action: PayloadAction<Record<string, string | number>>,
    ) => {
      state.filters = action.payload;
    },
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload;
    },
  },
});

export const {
  setPage,
  setLimit,
  setPaginatedData,
  setLastVisitedPage,
  setTransactionType,
  setCount,
  clearPaginatedData,
  setFilters,
  setSearchQuery,
} = PaginationSlice.actions;

export const selectPagination = (state: {
  TransactionPagination: IPaginationState;
}) => state.TransactionPagination;

export default PaginationSlice.reducer;
